var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMessageSent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24674 0.437028C8.01395 0.182023 7.63465 0.178807 7.39822 0.42986L2.96322 5.17841L1.03528 3.01619C0.805336 2.75656 0.424656 2.74804 0.185022 2.99714C-0.0546382 3.24625 -0.0625045 3.65865 0.16744 3.91826C0.168482 3.91942 0.169498 3.92057 0.17054 3.92173L2.52125 6.56083C2.63375 6.68516 2.7875 6.75556 2.94821 6.75626H2.95483C3.11249 6.75573 3.26367 6.68812 3.37578 6.568L8.24132 1.35625C8.47639 1.1037 8.47879 0.692822 8.24674 0.437028Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12954 6.56063C6.24175 6.68464 6.39502 6.75499 6.55531 6.75606H6.56193C6.71959 6.75553 6.87077 6.68792 6.98288 6.56779L11.8484 1.35605C12.069 1.08702 12.0465 0.675267 11.7981 0.436347C11.573 0.219747 11.2347 0.216897 11.0065 0.42966L6.57334 5.17821L6.41518 5.00035C6.18526 4.74072 5.80458 4.73217 5.56492 4.98128C5.32526 5.23036 5.31737 5.64276 5.54731 5.90239C5.54835 5.90358 5.54939 5.90473 5.55044 5.90589L6.12954 6.56063Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message_sent.707ea655.svg";
export { ForwardRef as ReactComponent };